export const CREATE_REPORT_MEASURES = ['measure_usd', 'measure_local', 'measure_constant'] as const;
export const CREATE_REPORT_DEFAULT_MEASURE = CREATE_REPORT_MEASURES[0];
export const CREATE_REPORT_DEFAULT_SOURCE = 'INGESTED';
export const CREATE_REPORT_SOURCE_OPTIONS = [
  { value: 'INGESTED', labelKey: 'createNativeSource', descriptionKey: 'createNativeDescription' },
  { value: 'EXTERNAL', labelKey: 'createExternalSource', descriptionKey: 'createExternalDescription' }
] as const;
